/* nesw-pack-stage.js — the pack stage (snippets/nesw-pack-stage.liquid) mirrors and drives the Ignis
   pack builder block. The block is the ONLY state: each visible `[data-ig-slot]` holds a colour group
   `[data-ig-axis="colour"]` and a size group `[data-ig-axis="size"]` of `[data-ig-val]` buttons which
   the block paints `is-on` (chosen), `is-oos` (not reachable with the other pick) and `disabled` (no
   stock at all). This reads those, draws one shirt per included slot with its colours and sizes, and a
   click here clicks the block's own button, so the block's rules (stock, pack size, price, cart line)
   are the ones that apply. Any change in the block repaints the stage (MutationObserver).

   The pack opens READY TO BUY (2026-10-29: the grey "pick every colour first" stage sold 0 of 134
   Shopping visits in a week). Once the block has booted, the stage presses the block's own buttons to
   give every slot a real colour, in the order of `data-defaults` (Black, White, Cream, Vintage Black),
   skipping a colour with no stock in the size, and the size the PDP prefers (L, M, XL, S, 2XL...) that
   has stock. One click on Add then buys a valid pack; the shopper changes any shirt or the size here. */
(function () {
  var stage = document.querySelector('[data-pack-stage]');
  if (!stage) return;
  var row = stage.querySelector('[data-nps-row]');
  var titleEl = stage.querySelector('[data-nps-title]');
  var subEl = stage.querySelector('[data-nps-sub]');
  var sizeEl = stage.querySelector('[data-nps-size]');
  var images = {};
  try { images = JSON.parse(stage.getAttribute('data-images') || '{}') || {}; } catch (e) { images = {}; }
  var base = stage.getAttribute('data-base') || '';
  var prefix = stage.getAttribute('data-title-prefix') || 'Your';
  var defaults = (stage.getAttribute('data-defaults') || '').split(',').map(key).filter(Boolean);
  /* The PDP's own size order (assets/product-add-to-cart.js autoSelectPreferredSize), plus the XXL spelling. */
  var SIZE_ORDER = ['l', 'm', 'xl', 's', '2xl', 'xxl', 'xs', '3xl', 'xxxl'];
  var block = null, raf = 0, lastHtml = '';
  /* Slots that have a colour ON THE STAGE (`touched`), and which of those the stage picked itself
     (`auto`). Indexed by slot position: the block hides the slots past the pack size, never earlier
     ones, so a visible slot's index is its index among all slots. A slot the stage picked is re-picked
     if its colour sells out in the size; a colour the shopper chose is never replaced. */
  var touched = {}, auto = {};
  var sizeAuto = true, filled = false, repairs = 0;
  var msgEl = null, holdMsg = '';

  function key(v) { return String(v || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function slots() { return block ? [].filter.call(block.querySelectorAll('[data-ig-slot]'), function (s) { return !s.hidden; }) : []; }
  function group(slot, axis) { return slot.querySelector('[data-ig-axis="' + axis + '"]'); }
  function buttons(g) { return g ? [].slice.call(g.querySelectorAll('[data-ig-val]')) : []; }
  function onBtn(g) { return buttons(g).filter(function (b) { return b.classList.contains('is-on'); })[0] || null; }
  /* `disabled`: no stock in any size. `is-oos`: none in the size this slot has now. */
  function inStock(b) { return !!b && !b.disabled && !b.classList.contains('is-oos'); }
  function allSlots() { return block ? [].slice.call(block.querySelectorAll('[data-ig-slot]')) : []; }
  /* A slot the block cannot buy as it stands: its colour has no stock in its size. */
  function broken(slot) {
    var cg = group(slot, 'colour'), sg = group(slot, 'size');
    if (buttons(cg).length && !inStock(onBtn(cg))) return true;
    return !!(buttons(sg).length && !inStock(onBtn(sg)));
  }

  /* ---- the opening pack ---------------------------------------------------------------------------- */
  function sizeRank(v, i) { var r = SIZE_ORDER.indexOf(key(v)); return r < 0 ? 100 + i : r; }
  /* The first size in the PDP's order with any colour in stock (a size button is disabled only when
     every colour of it is sold out). */
  function pickSize(slot) {
    var bs = buttons(group(slot, 'size')).map(function (b, i) { return { b: b, r: sizeRank(b.getAttribute('data-ig-val'), i) }; });
    bs = bs.filter(function (x) { return !x.b.disabled; }).sort(function (a, z) { return a.r - z.r; });
    return bs.length ? bs[0].b.getAttribute('data-ig-val') : null;
  }
  /* One size for the whole pack, through the block's pack-level row when it has one (the stage's
     size row presses the same), else each slot's own size button. */
  function setSize(value) {
    var pill = [].filter.call(block.querySelectorAll('[data-ig-pb-size] [data-ig-val]'), function (b) { return b.getAttribute('data-ig-val') === value; })[0];
    if (pill) { if (!pill.classList.contains('is-on')) pill.click(); return; }
    allSlots().forEach(function (slot) {
      var b = buttons(group(slot, 'size')).filter(function (x) { return x.getAttribute('data-ig-val') === value; })[0];
      if (b && !b.disabled && !b.classList.contains('is-on')) b.click();
    });
  }
  /* Slot i's colour: the defaults in order, then the block's other colours, stock in the slot's size
     only; the first one no other slot has, else the list again from the top (a 2-colour size gives
     Black, White, Black, White). */
  function chooseColour(slot, i, taken) {
    var bs = buttons(group(slot, 'colour')).filter(inStock);
    function rank(b, j) { var r = defaults.indexOf(key(b.getAttribute('data-ig-val'))); return r < 0 ? 100 + j : r; }
    var ranked = bs.map(function (b, j) { return { b: b, r: rank(b, j) }; }).sort(function (a, z) { return a.r - z.r; }).map(function (x) { return x.b; });
    if (!ranked.length) return null;
    var free = ranked.filter(function (b) { return taken.indexOf(key(b.getAttribute('data-ig-val'))) < 0; })[0];
    return free || ranked[i % ranked.length];
  }
  /* The block reports each change to the Ignis pixel as the shopper building the pack. These presses
     are the page's, not the shopper's: the pixel is out of reach while they run, and the block still
     records the result, so the shopper's first real change reports as their first step. */
  function quiet(fn) {
    var p = window.pxl;
    if (!p) return fn();
    try { window.pxl = null; fn(); } finally { window.pxl = p; }
  }
  /* Fill the pack (onlyBroken false, once the block has booted), or re-pick just the stage's own
     slots that a stock refresh or a size change left with no stock. */
  function fill(onlyBroken) {
    var all = allSlots();
    if (!all.length) return;
    /* 🔴 A ?variant= landing (an ad's size, a back-in-stock email, a reload after the shopper's own pick)
       already chose this pack, and the block honours it: the stage shows that choice and presses nothing,
       the same deep-link rule as autoSelectPreferredSize (review 2026-10-29: an M link was bought in L).
       Read the landing query, not location.search, which the block rewrites with replaceState. */
    if (!onlyBroken && /[?&]variant=/.test(String(window.__neswLandingSearch || ''))) {
      sizeAuto = false;
      all.forEach(function (slot, i) { touched[i] = true; auto[i] = false; });
      return;
    }
    quiet(function () {
      if (sizeAuto) {
        var cur = onBtn(group(all[0], 'size'));
        if (!onlyBroken || !cur || cur.disabled) { var s = pickSize(all[0]); if (s) setSize(s); }
      }
      var keep = all.map(function (slot, i) { return !!touched[i] && (!auto[i] || (onlyBroken && !broken(slot))); });
      var taken = all.map(function (slot, i) { var ob = keep[i] && onBtn(group(slot, 'colour')); return ob ? key(ob.getAttribute('data-ig-val')) : ''; });
      all.forEach(function (slot, i) {
        if (keep[i]) return;
        var b = chooseColour(slot, i, taken);
        if (!b) return; /* nothing in stock: the shirt stays grey and Add asks for a colour */
        taken[i] = key(b.getAttribute('data-ig-val'));
        if (!b.classList.contains('is-on')) b.click();
        touched[i] = true; auto[i] = true;
      });
    });
  }
  function needsRepair() {
    var all = allSlots();
    if (sizeAuto && all.length) { var cur = onBtn(group(all[0], 'size')); if (buttons(group(all[0], 'size')).length && (!cur || cur.disabled)) return true; }
    return all.some(function (slot, i) { return auto[i] && broken(slot); });
  }
  function swatchStyle(btn) {
    /* A colour with a cut-out shows ITS fabric (the chest of the photo): the block's swatch colours are
       approximations and read wrong beside the real shirt (Cream as yellow, Stone Blue as cyan). */
    var own = images[key(btn.getAttribute('data-ig-val'))];
    if (own) return 'background-image:url(' + JSON.stringify(own) + ');background-size:600%;background-position:50% 48%';
    var i = btn.querySelector('.ig-pb__swi'); if (!i) return '';
    var cs = window.getComputedStyle(i);
    var img = btn.querySelector('img.ig-pb__swf.is-on');
    if (img && img.currentSrc) return 'background-image:url(' + JSON.stringify(img.currentSrc) + ')';
    if (cs.backgroundImage && cs.backgroundImage !== 'none') return 'background-image:' + cs.backgroundImage;
    return 'background-color:' + cs.backgroundColor;
  }
  function swatchColour(btn) { var i = btn && btn.querySelector('.ig-pb__swi'); return i ? window.getComputedStyle(i).backgroundColor : '#333'; }

  function teeHtml(colourBtn) {
    if (!colourBtn) return '<div class="nps__tee is-empty"><img src="' + esc(base) + '" alt="" loading="eager" decoding="async"></div>';
    var name = colourBtn.getAttribute('data-ig-val'), src = images[key(name)];
    if (src) return '<div class="nps__tee"><img src="' + esc(src) + '" alt="' + esc(name) + ' tee" decoding="async"></div>';
    return '<div class="nps__tee nps__tee--tint" style="--nps-c:' + esc(swatchColour(colourBtn)) + ';--nps-mask:url(' + esc(base) + ')"><span class="nps__tint"></span><img src="' + esc(base) + '" alt="' + esc(name) + ' tee" decoding="async"></div>';
  }

  /* The ACTIVE shirt: the one the colour row below applies to. Clicking a shirt selects it; picking a
     colour moves on to the next grey shirt, so a pack is built pick, pick, pick. */
  var active = 0, open = false;
  function nextOpen(list, from) {
    for (var k = 0; k < list.length; k++) { var j = (from + k) % list.length; if (!touched[j] && buttons(group(list[j], 'colour')).length > 1) return j; }
    return -1;
  }
  function render() {
    raf = 0;
    if (!block) return;
    /* Until the block has booted, keep the server-drawn shirts (already in the default colours): drawing
       from the unbound block would flash grey placeholders. The observer re-runs this on data-ig-bound. */
    if (!filled && !block.hasAttribute('data-ig-bound')) return;
    /* `data-ig-bound` is set as the block's init starts, and init runs in one go, so once it is visible
       here the block's buttons are live. The repair is capped: stock never flips back and forth, so a
       loop here would be a bug, and the stage must never spin on one. */
    if (!filled && block.hasAttribute('data-ig-bound')) { filled = true; fill(false); }
    else if (filled && repairs < 12 && needsRepair()) { repairs++; fill(true); }
    var list = slots(), html = '';
    if (active >= list.length) active = Math.max(0, list.length - 1);
    /* A pack sold in ONE size (the block shows its pack-level size row) gets one size row for the pack. */
    var packSize = block.querySelector('[data-ig-pb-size]'), uniform = !!(packSize && !packSize.hidden && packSize.querySelector('[data-ig-val]'));
    /* The shirts, overlapping like the pack photo: each tucks under the next, the right one in front. */
    html += '<div class="nps__strip" role="radiogroup" aria-label="Shirts in your pack">';
    list.forEach(function (slot, i) {
      var cbs = buttons(group(slot, 'colour'));
      var picked = !!touched[i] || cbs.length < 2;
      var chosen = picked ? (cbs.filter(function (b) { return b.classList.contains('is-on'); })[0] || null) : null;
      html += '<button type="button" class="nps__pick' + (i === active ? ' is-active' : '') + (picked ? '' : ' is-open') + '" data-i="' + i + '" role="radio" aria-checked="' + (i === active ? 'true' : 'false') + '" aria-label="Shirt ' + (i + 1) + (chosen ? ', ' + esc(chosen.getAttribute('data-ig-val')) : ', no color yet') + '" style="z-index:' + (i + 1) + '">' + teeHtml(chosen) + '<span class="nps__num">' + (i + 1) + '</span></button>';
    });
    html += '</div>';
    /* The picker card for the active shirt, only once a shirt is clicked (Jay 2026-09-25: the swatches and
       sizes stay out of sight until then). It floats over the page, so opening it moves nothing. */
    var act = open ? list[active] : null;
    if (act) {
      var cbs = buttons(group(act, 'colour')), actPicked = !!touched[active] || cbs.length < 2;
      var onBtn = actPicked ? cbs.filter(function (b) { return b.classList.contains('is-on'); })[0] : null;
      html += '<div class="nps__panel" role="dialog" aria-label="Shirt ' + (active + 1) + ' options"><button type="button" class="nps__x" data-close aria-label="Close">×</button><span class="nps__panel-l">Shirt ' + (active + 1) + ' of ' + list.length + (onBtn ? ' · ' + esc(onBtn.getAttribute('data-ig-val')) : ' · pick a color') + '</span>';
      if (cbs.length > 1) html += '<div class="nps__colors" role="group" aria-label="Shirt ' + (active + 1) + ' color">' + cbs.map(function (b, j) {
        var v = b.getAttribute('data-ig-val'), on = actPicked && b.classList.contains('is-on');
        return '<button type="button" class="nps__c' + (on ? ' is-on' : '') + (b.classList.contains('is-oos') ? ' is-oos' : '') + '"' + (b.disabled ? ' disabled' : '') + ' data-axis="colour" data-j="' + j + '" style="' + esc(swatchStyle(b)) + '" title="' + esc(v) + '" aria-label="' + esc(v) + '" aria-pressed="' + (on ? 'true' : 'false') + '"></button>';
      }).join('') + '</div>';
      var sbs = buttons(group(act, 'size'));
      if (sbs.length && !uniform) html += '<div class="nps__sizes" role="group" aria-label="Shirt ' + (active + 1) + ' size">' + sbs.map(function (b, j) {
        var v = b.getAttribute('data-ig-val');
        return '<button type="button" class="nps__s' + (b.classList.contains('is-on') ? ' is-on' : '') + (b.classList.contains('is-oos') ? ' is-oos' : '') + '"' + (b.disabled ? ' disabled' : '') + ' data-axis="size" data-j="' + j + '" aria-pressed="' + (b.classList.contains('is-on') ? 'true' : 'false') + '">' + esc(v) + '</button>';
      }).join('') + '</div>';
      html += '</div>';
    }
    if (html !== lastHtml) {
      lastHtml = html;
      row.innerHTML = html;
    }
    /* The pack's one size sits under the shirts, always in sight: the pack is bought without opening a
       shirt, so the size it goes in at must be on the page, not only inside the card. */
    if (sizeEl) {
      var sizeHtml = uniform ? packSizeHtml(packSize) : '';
      if (sizeEl.innerHTML !== sizeHtml) sizeEl.innerHTML = sizeHtml;
      sizeEl.hidden = !uniform;
    }
    /* A shirt the block cannot buy (a colour the shopper chose has no stock in the size) says so here:
       the block greys Add out then, so a click on it would never reach the hold below. */
    var bad = -1;
    list.some(function (s, i) { if (touched[i] && broken(s)) { bad = i; return true; } return false; });
    var hm = bad >= 0 ? 'Shirt ' + (bad + 1) + ' is sold out in that color and size. Pick another color.' : '';
    if (msgEl && hm !== holdMsg) { if (hm || msgEl.textContent === holdMsg) msgEl.textContent = hm; holdMsg = hm; }
    placePanel();
    row.style.setProperty('--nps-n', String(Math.max(1, list.length)));
    row.setAttribute('data-n', String(list.length));
    if (titleEl) titleEl.textContent = list.length ? prefix + ' ' + list.length + '-pack' : 'Pick your colors';
    if (subEl) {
      var now = block.querySelector('[data-ig-pb-now]'), was = block.querySelector('[data-ig-pb-was]');
      var nowT = now ? (now.textContent || '').trim() : '', wasT = was && !was.hidden ? (was.textContent || '').trim() : '';
      function clean(t) { return t.replace(/\.00(?!\d)/g, ''); }
      nowT = clean(nowT); wasT = clean(wasT);
      var p = []; if (list.length) p.push(list.length + ' tees');
      var priceHtml = nowT ? (wasT && wasT !== nowT ? '<s>' + esc(wasT) + '</s> ' : '') + '<b>' + esc(nowT) + '</b>' : '';
      subEl.innerHTML = p.map(esc).join('') + (priceHtml ? ' · ' + priceHtml : '');
    }
  }
  function packSizeHtml(packSize) {
    return '<div class="nps__packsize"><span class="nps__packsize-l">Size, whole pack</span><div class="nps__sizes" role="group" aria-label="Pack size">' + [].map.call(packSize.querySelectorAll('[data-ig-val]'), function (b, j) {
      var v = b.getAttribute('data-ig-val');
      return '<button type="button" class="nps__s' + (b.classList.contains('is-on') ? ' is-on' : '') + (b.classList.contains('is-oos') ? ' is-oos' : '') + '"' + (b.disabled ? ' disabled' : '') + ' data-axis="packsize" data-j="' + j + '" aria-pressed="' + (b.classList.contains('is-on') ? 'true' : 'false') + '">' + esc(v) + '</button>';
    }).join('') + '</div></div>';
  }
  /* The card sits under the active shirt, kept inside the stage's width. */
  function placePanel() {
    var panel = row.querySelector('.nps__panel'), pick = row.querySelector('.nps__pick.is-active');
    if (!panel || !pick) return;
    var rr = row.getBoundingClientRect(), pr = pick.getBoundingClientRect(), pw = panel.offsetWidth;
    var cx = pr.left + pr.width / 2 - rr.left, left = Math.max(0, Math.min(rr.width - pw, cx - pw / 2));
    panel.style.left = left + 'px';
    panel.style.top = (pr.bottom - rr.top + 22) + 'px'; /* below the shirt's number badge */
    panel.style.setProperty('--nps-arrow', (cx - left) + 'px');
  }
  window.addEventListener('resize', function () { if (open) placePanel(); });
  /* Click away or Esc closes the card. */
  document.addEventListener('click', function (e) { if (open && !stage.contains(e.target) && !(block && block.contains(e.target))) { open = false; lastHtml = ''; schedule(); } });
  document.addEventListener('keydown', function (e) { if (open && e.key === 'Escape') { open = false; lastHtml = ''; schedule(); } });
  function schedule() { if (!raf) raf = requestAnimationFrame(render); }

  row.addEventListener('click', function (e) {
    var pick = e.target.closest && e.target.closest('.nps__pick');
    if (pick) { var pi = +pick.getAttribute('data-i'); open = !(open && pi === active); active = pi; lastHtml = ''; schedule(); return; }
    if (e.target.closest && e.target.closest('[data-close]')) { open = false; lastHtml = ''; schedule(); return; }
    var b = e.target.closest && e.target.closest('button[data-axis]');
    if (!b || b.disabled) return;
    var list = slots(), slot = list[active]; if (!slot) return;
    var target = buttons(group(slot, b.getAttribute('data-axis')))[+b.getAttribute('data-j')];
    if (target && !target.disabled) {
      target.click();
      if (b.getAttribute('data-axis') === 'colour') {
        touched[active] = true; auto[active] = false; if (msgEl) msgEl.textContent = '';
        var nx = nextOpen(list, active + 1); if (nx >= 0) active = nx; else open = false;
      } else sizeAuto = false;
      lastHtml = '';
    }
    schedule();
  });
  if (sizeEl) sizeEl.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[data-axis="packsize"]');
    if (!b || b.disabled) return;
    var pb = block && block.querySelectorAll('[data-ig-pb-size] [data-ig-val]')[+b.getAttribute('data-j')];
    if (pb && !pb.disabled) { sizeAuto = false; pb.click(); }
    schedule();
  });

  function attach() {
    block = document.querySelector('.ig-pb[data-ig-pack]');
    if (!block) return false;
    document.body.classList.add('nps-on');
    msgEl = stage.querySelector('[data-nps-msg]');
    if (!msgEl) { msgEl = document.createElement('p'); msgEl.className = 'nps__msg'; msgEl.setAttribute('role', 'status'); stage.appendChild(msgEl); }
    /* Add is held only while a shirt is still grey, which after the fill means its product had no
       colour in stock in the size: the shopper is pointed at that shirt instead of an error. */
    var add = block.querySelector('[data-ig-pack-add]');
    if (add) add.addEventListener('click', function (e) {
      var list = slots(), first = nextOpen(list, 0);
      if (first < 0) return;
      e.preventDefault(); e.stopImmediatePropagation();
      msgEl.textContent = 'Pick a color for shirt ' + (first + 1) + '.';
      active = first; open = true; lastHtml = ''; render();
      var el = row.querySelector('.nps__pick[data-i="' + first + '"]');
      if (el) { el.classList.remove('is-nudge'); void el.offsetWidth; el.classList.add('is-nudge'); }
      stage.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, true);
    new MutationObserver(schedule).observe(block, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden', 'disabled', 'aria-pressed', 'style', 'data-ig-bound'] });
    render();
    return true;
  }
  /* The app block may initialise after this script: try now, then on each frame for a few seconds. */
  if (!attach()) {
    var tries = 0;
    (function again() { if (attach() || ++tries > 300) return; requestAnimationFrame(again); })();
  }
})();
